import { render, staticRenderFns } from "./PatientFormDialog.vue?vue&type=template&id=f9592bc2&scoped=true"
import script from "./PatientFormDialog.vue?vue&type=script&lang=js"
export * from "./PatientFormDialog.vue?vue&type=script&lang=js"
import style0 from "./PatientFormDialog.vue?vue&type=style&index=0&id=f9592bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9592bc2",
  null
  
)

export default component.exports